import { createTheme } from '@mui/material/styles';

// Custom theme for Osperb
const theme = createTheme({
  palette: {
    primary: {
      main: '#1881bb', // Osperb blue
      light: '#4fa8d8',
      dark: '#0f5f8a',
      contrastText: '#ffffff',
    },
    darkBlue: {
      main: '#0044FF',
      light: '#1F5BFF',
      dark: '#0033CC',
      contrastText: '#ffffff',
    } as any,
    secondary: {
      main: '#333333', // Navigation color
      light: '#666666',
      dark: '#1a1a1a',
      contrastText: '#ffffff',
    },
    background: {
      default: '#ffffff',
      paper: '#f5f5f7', // bg-myGray
    },
    text: {
      primary: '#000000',
      secondary: '#333333',
    },
    grey: {
      50: '#f5f5f7',
      100: '#f2f2f2',
      200: '#e0e0e0',
      300: '#bdbdbd',
      400: '#9ca3af',
      500: '#666666',
      600: '#333333',
      700: '#1a1a1a',
      800: '#000000',
    },
  },
  typography: {
    fontFamily:
      '"Montserrat", "Poppins", system-ui, -apple-system, "Segoe UI", Helvetica, Arial, sans-serif',
    h1: {
      fontFamily: '"Montserrat", sans-serif',
      fontWeight: 700,
      fontSize: '2.5rem',
      lineHeight: 1.2,
    },
    h2: {
      fontFamily: '"Montserrat", sans-serif',
      fontWeight: 600,
      fontSize: '2rem',
      lineHeight: 1.3,
    },
    h3: {
      fontFamily: '"Montserrat", sans-serif',
      fontWeight: 600,
      fontSize: '1.75rem',
      lineHeight: 1.3,
    },
    h4: {
      fontFamily: '"Montserrat", sans-serif',
      fontWeight: 500,
      fontSize: '1.5rem',
      lineHeight: 1.4,
    },
    h5: {
      fontFamily: '"Montserrat", sans-serif',
      fontWeight: 500,
      fontSize: '1.25rem',
      lineHeight: 1.4,
    },
    h6: {
      fontFamily: '"Montserrat", sans-serif',
      fontWeight: 500,
      fontSize: '1rem',
      lineHeight: 1.5,
    },
    body1: {
      fontFamily: '"Montserrat", sans-serif',
      fontSize: '1rem',
      lineHeight: 1.6,
    },
    body2: {
      fontFamily: '"Montserrat", sans-serif',
      fontSize: '0.875rem',
      lineHeight: 1.6,
    },
    button: {
      fontFamily: '"Montserrat", sans-serif',
      fontWeight: 500,
      textTransform: 'none', // Disable uppercase transformation
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          textTransform: 'none',
          fontWeight: 500,
          padding: '10px 24px',
          fontSize: '1rem',
          '&:hover': {
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.12)',
          },
        },
        contained: {
          '&:hover': {
            backgroundColor: '#0f5f8a',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: '12px',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.07)',
          '&:hover': {
            boxShadow: '0 8px 15px rgba(0, 0, 0, 0.12)',
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: '8px',
            backgroundColor: '#dcdcdc4f', // Same as your input_bg
            '& fieldset': {
              borderColor: '#e0e0e0',
            },
            '&:hover fieldset': {
              borderColor: '#1881bb',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#1881bb',
            },
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#333333', // navColor
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: '16px',
        },
      },
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 768, // Your mobile breakpoint
      lg: 1024,
      xl: 1340,
    },
  },
  spacing: 8, // 8px base spacing unit
});

export default theme;
